import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { MultilingualService } from 'src/app/core/services/multilingual/multilingual.service';
import { MailOrderProfileEnrollmentService } from 'src/app/services/mail-order-profile-enrollment/mail-order-profile-enrollment.service';
import { UserService } from 'src/app/services/user/user.service';
import { PmartPatientEnrollmentFormComponent } from '../mail-order-patient-enrollment-form/mail-order-patient-enrollment-form.component';

@Component({
  selector: 'app-mail-order-profile-pending',
  templateUrl: './mail-order-profile-pending.component.html',
  styleUrls: ['./mail-order-profile-pending.component.scss']
})
export class MailOrderProfilePendingComponent implements OnInit, OnDestroy {
  @Input() pageName!: string;
  subscription: Subscription = new Subscription();
  showUpdateProfileDialog$!: Observable<boolean>;
  showUpdateProfile: boolean = false;

  constructor(
    public readonly userService: UserService,
    public readonly multilingualService: MultilingualService,
    private readonly dialog: MatDialog,
    public mailOrderService: MailOrderProfileEnrollmentService,
  ) { }

  ngOnInit(): void {
    this.refreshMailOrderProfile();

    this.subscription.add(this.mailOrderService.showUpdateProfileMessage$.subscribe((res) => {
      this.showUpdateProfile = res
    }));

    this.subscription.add(this.mailOrderService.hideUpdateProfileMessage$.subscribe((hide) => {
      if (hide) {
        this.refreshMailOrderProfile();
      }
    }))
  }

  public updateMailOrderProfile() {
    const member = this.userService.member;
    const dialogRef2 = this.dialog.open(PmartPatientEnrollmentFormComponent,  {
      height: 'auto',
      width: '60vw',
      data: { member, pageName: this.pageName} ,
      disableClose: true,
      panelClass: 'update-profile-dialog',
    });
    return dialogRef2.afterClosed().subscribe((result) => {
      if (result == 'submit') {
        this.refreshMailOrderProfile();
      }
    });
  }

  public hideUpdateProfileDialog() {
    this.mailOrderService.showUpdateProfileMessage$.next(false);
  }

  private refreshMailOrderProfile() {
    this.showUpdateProfileDialog$ = this.mailOrderService.showUpdateProfileDialog();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}